module.exports = __webpack_public_path__ + "static/media/piggy.7584c791.gif";